import { stringifyGraph } from '@/clients/http'
import { BrandModel as BrandApi } from '@/http/models/brand/Brand'

import { UseFetchListForm, useFetchList } from '@/hooks/useFetchList'

import { BrandHttpParams, BrandModel, BrandResponses } from '@/types'

export interface BrandListFilters {
  search?: string
  status?: 'active' | 'inactive' | null
}

export interface BrandListForm extends UseFetchListForm<BrandListFilters, BrandModel.Brand> {}

interface UseFetchBrandsProps {
  sort?: string | null
  shouldFetchList?: boolean
}

export const brandInitialFilters: BrandListFilters = {
  search: '',
  status: null,
}

export const useFetchBrands = ({ sort, shouldFetchList }: UseFetchBrandsProps) => {
  return useFetchList<BrandListFilters, BrandModel.Brand, {}, any, typeof BrandApi.getList>({
    pageSize: 10,
    initialFilters: brandInitialFilters,
    fetchFunction: BrandApi.getList,
    sort,
    register: shouldFetchList,
    buildQueryParams: (filters): Partial<BrandHttpParams.GetList['query']> => ({
      search: filters.search || undefined,
      status: filters.status || undefined,
      graph_enc: stringifyGraph({
        '*': true,
        logo: {
          path: true,
          versions: true,
        },
        'products.count': true,
      }),
    }),
    buildParams: () => ({}),
  })
}
